import React, { useEffect } from "react";
import { useTranslation } from "gatsby-plugin-react-i18next";
import { useFormikContext } from "formik";

import FormWrapper from "../FormWrapper";
import FormGroup from "../FormGroup";
import { Field, FieldGroup } from "components/Design/Input/Field";
import Select, { SelectOption } from "components/Design/Input/Select/Select";
import Textarea from "components/Design/Input/Textarea";
import Checkbox from "components/Design/Input/Checkbox";
import { ContactInformation } from "../CommonField";

const GeneralInquiry = ({ setSelectedDestination }) => {
  const { t } = useTranslation("support");
  const { values } = useFormikContext();

  const subjectOption = [
    { label: t("Stay"), value: "Stay" },
    { label: t("Dining"), value: "Dining" },
    { label: t("Romantic Dining"), value: "Romantic Dining" },
    { label: t("Spa"), value: "Spa" },
    { label: t("Other"), value: "Other" },
  ];

  const titleOption = [
    { label: t("Mr"), value: "Mr" },
    { label: t("Ms"), value: "Ms" },
  ];

  useEffect(() => {
    if (values.subject) setSelectedDestination(values?.subject);
  }, [values.subject]);

  return (
    <FormWrapper title={t("General Inquiry")}>
      <FormGroup>
        <Field name="subject" label={t("Subject")}>
          <Select>
            {subjectOption.map((item) => (
              <SelectOption key={item.value} value={item.value}>
                {item.label}
              </SelectOption>
            ))}
          </Select>
        </Field>

        <Field name="inquiry" label={t("Inquiry")}>
          <Textarea />
        </Field>

        <FieldGroup name="promotional">
          <Checkbox type="checkbox">{t("receiveNewsletters")}</Checkbox>
        </FieldGroup>
      </FormGroup>

      <ContactInformation t={t} titleOption={titleOption} />
    </FormWrapper>
  );
};

export default GeneralInquiry;
